import * as React from 'react';
import { ViewSettingsActions } from '../actions/ViewSettingsActions';
import { UIHelper } from '../utils/UIHelper';
import { ClickButton } from './ClickButton';

interface MessageBoxContentState {
}

export interface MessageBoxContentProps {
    submitCallback?: () => void;
    submitText?: string;

    cancelCallback?: () => void;
    cancelText?: string;

    backgroundClickCallback?: (event: React.MouseEvent) => void;

    wideButtons?: boolean;
}

export class MessageBoxContent extends React.Component<MessageBoxContentProps, MessageBoxContentState> {
    public render(): JSX.Element {
        return (
            <div className="dialog-page" onClick={this.backgroundClick}>
                <div className={'dialog-page-resizer' + (this.props.wideButtons ? ' wide-buttons' : '')} onClick={UIHelper.stopEvent}>
                    <div className="dialog-page-header">{this.props.children}</div>
                    {this.cancelButton()}
                    {this.submitButton()}
                </div>
            </div>
        );
    }

    protected submitButton = (): JSX.Element | null => {
        if (this.props.submitText == null) {
            return null;
        }

        return (
            <ClickButton
                className={'submit-button' + (this.props.cancelText == null ? ' full-button' : '')}
                callback={this.submit}
            >
                {this.props.submitText}
            </ClickButton>
        );
    };

    protected cancelButton = (): JSX.Element | null => {
        if (this.props.cancelText == null) {
            return null;
        }

        return (
            <ClickButton
                className={'cancel-button' + (this.props.submitText == null ? ' full-button' : '')}
                callback={this.cancel}
            >
                {this.props.cancelText}
            </ClickButton>
        );
    };

    protected cancel = (): void => {
        ViewSettingsActions.closeMessage();

        if (this.props.cancelCallback != null) {
            this.props.cancelCallback();
        }
    };

    protected submit = (): void => {
        ViewSettingsActions.closeMessage();

        if (this.props.submitCallback != null) {
            this.props.submitCallback();
        }
    };

    protected backgroundClick = (event: React.MouseEvent): void => {
        if (this.props.backgroundClickCallback != null) {
            this.props.backgroundClickCallback(event);
        } else {
            UIHelper.stopEvent(event);
        }
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MessageBoxContent.tsx